import { importHighcharts } from '@/lib/highcharts'
import { BlockModule } from '../common'
import {
    doIfInViewOrDefer,
    trendColorClasses,
    trendIconClasses,
    setupChartCounters,
} from './common'
import { getMarketDataHeadlineInflationMonthlyBreakdown } from '@/api'
import { defineComponent } from 'vue'
import ChartShareButtons from '@/components/website/ChartShareButtons.vue'
import { parseISO } from 'date-fns'

new BlockModule({
    selector: '.block-market-data-headline-inflation-monthly-breakdown',
    vueComponent: defineComponent({
        components: { ChartShareButtons },
        setup() {},
    }),
    async setupBlock(el, onTeardown, blockContext) {
        const chartData = await getMarketDataHeadlineInflationMonthlyBreakdown()

        const latestValue = chartData.data[chartData.data.length - 1]
        const beforeLatestValue = chartData.data[chartData.data.length - 2]
        const valueDelta = (latestValue.y || 0) - (beforeLatestValue.y || 0)

        const timestamp = chartData.lastUpdated
        const date = new Date(timestamp)
        const lastUpdatedValue = date
            .toLocaleDateString('en-US', {
                day: 'numeric',
                month: 'short',
                year: 'numeric',
            })
            .replace(',', '')
        let trend: keyof typeof trendColorClasses & keyof typeof trendIconClasses = 'neutral'

        if (valueDelta > 0) {
            trend = 'positive'
        } else if (valueDelta < 0) {
            trend = 'negative'
        }

        const setupChart = async () => {
            const chartEl = el.querySelector('.chart-container')
            if (!chartEl) return

            const Highcharts = await importHighcharts()

            const dataOverTime = chartData.data.map((point) => {
                return [parseISO(point.x + 'Z').valueOf(), point.y]
            })

            const chart = Highcharts.chart({
                chart: {
                    type: 'line',
                    renderTo: chartEl as HTMLElement,
                },
                title: {
                    text: '',
                },
                xAxis: {
                    labels: {
                        format: '{value:%Y}',
                    },
                    type: 'datetime',
                    lineColor: '#DBDBDB',
                },
                yAxis: {
                    color: '#DBDBDB',
                    title: {
                        text: '(%)',
                        align: 'high',
                        rotation: 0,
                        reserveSpace: false,
                        textAlign: 'left',
                        y: -20,
                    },
                },
                series: [
                    {
                        name: chartData.yLabel,
                        type: 'line',
                        color: '#010066',
                        data: dataOverTime,
                        marker: {
                            enabled: true,
                            symbol: 'circle',
                            radius: 3,
                        },
                    },
                ],
                exporting: {
                    enabled: false,
                    filename: 'headline-inflation-monthly-breakdown',
                },
            })

            const download = el.querySelector<HTMLButtonElement>('.download-btn')
            if (download) {
                download.addEventListener('click', () => {
                    chart.downloadCSV()
                })
            }

            onTeardown(() => {
                chart.destroy()
            })
        }

        doIfInViewOrDefer(() => {
            setupChart()
            setupChartCounters(
                el,
                trend,
                latestValue,
                beforeLatestValue,
                null,
                valueDelta,
                timestamp,
                lastUpdatedValue,
                null,
                null,
                null,
                null,
                false,
            )
        }, blockContext)
    },
})
